import { connect } from 'react-redux'
import { getUserRole } from '../../redux/user/selectors'
import RouteMain from '../../routes/main'

const mapStateToProps = (state) => ({
  userRole: getUserRole(state),
})

export default connect(mapStateToProps, null)(RouteMain)
